import { Box, styled } from '@mui/material'
import { keyframes } from '@mui/system'
import React from 'react'

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const ToastContainer = styled('div')(() => ({
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  zIndex: 9999,
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '12px',
  alignItems: 'flex-end',
}))

export const LoaderCard = styled('div')(() => ({
  position: 'relative',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '16px 20px',
  minWidth: '280px',
  maxWidth: '360px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '14px',
  pointerEvents: 'auto',
}))

export const MinimizeButton = styled('button')(() => ({
  position: 'absolute',
  top: '8px',
  right: '8px',
  width: '24px',
  height: '24px',
  borderRadius: '6px',
  border: 'none',
  backgroundColor: 'transparent',
  color: '#94a3b8',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.15s ease',
  '&:hover': {
    backgroundColor: '#f1f5f9',
    color: '#64748b',
  },
}))

export const SpinnerWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  paddingTop: '2px',
}))

export const Spinner = styled('div')(() => ({
  width: '24px',
  height: '24px',
  border: '3px solid #e2e8f0',
  borderTop: '3px solid #3b82f6',
  borderRadius: '50%',
  animation: `${spin} 1s linear infinite`,
}))

export const LoaderTextWrapper = styled(Box)(() => ({
  fontSize: 14,
  color: '#1e293b',
  lineHeight: 1.5,
  flex: 1,
  minWidth: 0,
}))

export const ProgressBarContainer = styled('div')(() => ({
  width: '100%',
  height: '6px',
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  borderRadius: '3px',
  overflow: 'hidden',
  marginTop: '10px',
}))

export const ProgressBarFill = styled('div')(() => ({
  height: '100%',
  transition: 'width 0.3s ease-in-out',
  borderRadius: '3px',
}))

export const ProgressText = styled('div')(() => ({
  marginTop: '6px',
  fontSize: '12px',
  color: '#64748b',
}))

export const Tag = styled('span')(() => ({
  display: 'inline-block',
  padding: '2px 8px',
  fontSize: '10px',
  fontWeight: 600,
  color: '#475569',
  width: '50px',
  backgroundColor: '#f1f5f9',
  borderRadius: '4px',
  textTransform: 'uppercase',
  letterSpacing: '0.025em',
  marginLeft: '8px',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
}))

export const InfoWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

// Minimized styles
export const MinimizedContainer = styled('div')(() => ({
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '8px',
  alignItems: 'flex-end',
}))

export const MinimizedCard = styled('div')(() => ({
  backgroundColor: '#ffffff',
  borderRadius: '10px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
  width: '110px',
  gap: '10px',
  cursor: 'pointer',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  animation: `${scaleIn} 0.2s ease-out`,
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1)',
  },
}))

export const MinimizedTag = styled('span')(() => ({
  fontSize: '8px',
  fontWeight: 600,
  color: '#475569',
  backgroundColor: '#f1f5f9',
  padding: '2px 6px',
  borderRadius: '4px',
  textTransform: 'uppercase',
  letterSpacing: '0.025em',
  whiteSpace: 'nowrap',
  maxWidth: '80px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))
